import React, { useEffect } from 'react';
// import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { useUser } from "../context/UserContext";
import axios from 'axios';
import config from '../config';
import FacebookLogin from '@greatsumini/react-facebook-login';
import facebookLogo from "../assets/Facebook-icon.jpg"
import { toast } from 'react-toastify';

export default function LoginFacebook({ setLoading }) {
    // const navigate = useNavigate();
    const { loginUser } = useUser();
    const [cookies, setCookie] = useCookies([]);

    useEffect(() => {
        window.fbAsyncInit = () => {
          window.FB.init({
            appId: config.facebookAppId,
            cookie: true,
            xfbml: true,
            version: "v19.0"
          });
        };
      
        // Load the SDK script dynamically
        const script = document.createElement('script');
        script.src = "https://connect.facebook.net/en_US/sdk.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    const handleFacebookLogin = async (fbResponse) => {
        // console.log(fbResponse)
        // {
        //     "userID": "1220690996341889",
        //     "expiresIn": 4019,
        //     "accessToken": "EAAJhu3Ng724BOzCKMuZA5NldlF6afwK9oEKueOo4Gur4AfAC1jazAh4XS1zfv4keSOCGX7bzJelEdzDnvILBCtVg2GJy6ahIYwvMDVGzKtJ6Hn5LZB1eBlmKLnvxj5eOZCDzPRArQt0BE5ZAm1muf5kZCNOcC7UQI5bHQ7ZBytmY9IFoRRfBA27SCKhEI3BDsxs2i0vhStlQvG8OvZBKc1IdTumfQZDZD",
        //     "signedRequest": "H8mYbJprZnLP3KhwnEtqyAf3ep9xhbtfokhL3dEseuo.eyJ1c2VyX2lkIjoiMTIyMDY5MDk5NjM0MTg4OSIsImNvZGUiOiJBUURHbHFJR1FManhmelQ1VGtLSHo2Z2xPVU9nWnBjQUxfWW9GZ3EzbENjcEF3cEZSR2F3M24taUZ0U1pmT1QwX3dTZ0ZVUHRlTU1mQUp3TlNtMjBaTVoxcnZFVFU1LVJiTEZZZFF6akpTRmFTUk1STHNaa3VuUmNxVkhsQzVUNGZmaXBHN1Q2eExnRGdzYTd5b2QtOTZnWFctb3FNd2lWNTZWTHhlOEUxa2oweW1KcVdpZXFIY3VOcTdSOXc0Q3FDcEpUNHM0ZTBINDR3LWppOWdhWmt3OG5SblJ1dEdLLU5VSjN6MFBFM2JtSnpPeDgxLTJSYjRxbG1MdEZ0a04xajFnVjdVcXJBckdGbjBZM0EzQjVjQzBkMUs0Wmc0Q2pNMllGRHNmMXVHSm1JUlFDQWpYVGpHRDN2US1wNjdrOERsUWktTUZIOGcwN0tVX3ROUWc4TkY4UCIsImFsZ29yaXRobSI6IkhNQUMtU0hBMjU2IiwiaXNzdWVkX2F0IjoxNzQ1MTk2NzgyfQ",
        //     "graphDomain": "facebook",
        //     "data_access_expiration_time": 1752972781
        // }

        setLoading(true);
        try {
            // console.log(fbResponse);
            const response = await axios.post(`${config.apiBaseUrl}/auth/facebook`, fbResponse);
            if (response.status === 200){
                // console.log('User login successfully');
                console.log(response.data);
                loginUser(response.data.user_data);

                // server response cannot set cookie in redirect
                const cookie_data = response.data.cookie_data;
                setCookie(cookie_data.key, cookie_data.value, {
                    expires: new Date(Date.now() + cookie_data.max_age * 1000),
                    secure: true,
                    sameSite: 'lax'
                });

                // navigate("/");
            }
        } catch (error) {
            // console.log(error)
            toast.error("Login failed")
        } finally {
            setLoading(false);
        }
    };

    return (
        <FacebookLogin
            appId={config.facebookAppId}
            onSuccess={handleFacebookLogin}
            onFail={(error) => console.error(error)}
        >
            <img
                src={facebookLogo}
                alt="Facebook Login"
                className="w-10 h-10 mx-4 duration-300 hover:scale-120"
            />
        </FacebookLogin>
    );
};


